import React from "react";
import AtmFees from "../../modules/atmFees";

const AtmFeesPage = () => {
  return <AtmFees />;
};

export default AtmFeesPage;
